
function positionNavSmiles() {
  const navItems = document.querySelectorAll('.navmenu-item');

  navItems.forEach((item) => {
    const svg = item.querySelector('.nav-smile');

    if (svg) {
      // Get the position and dimensions of the nav item
      const rect = item.getBoundingClientRect();

      // Apply absolute positioning to the SVG
      svg.style.position = 'absolute';
      // svg.style.top = `${rect.bottom + window.scrollY}px`; // Position below nav item
      svg.style.left = `${rect.left + rect.width / 2 - svg.getBoundingClientRect().width / 2}px`; // Center horizontally
    }
  });
}

// Trigger positioning on DOMContentLoaded and window resize
document.addEventListener("DOMContentLoaded", positionNavSmiles);
window.addEventListener("resize", positionNavSmiles);



//vanilla js on dom load

const headerSearch = () => {
  const searchIcon = document.querySelector('.search-button-header');
  const liveSearch = document.querySelector('.live-search');
  const closeSearch = document.querySelector('.close-button-search');
  const input = document.querySelector('.live-search-form-field');

  closeSearch.addEventListener('click', function() {
    console.log('clicked search');
    liveSearch.classList.remove('active');
  })

  searchIcon.addEventListener('click', function() {
    console.log('clicjed search')
    liveSearch.classList.toggle('active');
    input.focus();

  })
}

document.addEventListener('DOMContentLoaded', function() {
  headerSearch()

  let lastScrollTop = 0;
  const header = document.querySelector('.site-header');

  window.addEventListener('scroll', function() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (scrollTop > 100) {
          if (scrollTop > lastScrollTop) {
              // Scrolling down past 300px
              header.classList.add('hidden');
          } else {
              // Scrolling up past 300px
              header.classList.remove('hidden');
          }
      } else {
          // Ensure header is visible when above 300px
          header.classList.remove('hidden');
      }
      
      lastScrollTop = scrollTop;
  });



  const swipers = document.querySelectorAll('.swiper');

  swipers.forEach((swiperWrap) => {
    const sliderType = swiperWrap.getAttribute('data-section');
    let swiper
    let pagination = swiperWrap.querySelector('.swiper-pagination');

    console.log(swiperWrap);

    switch (sliderType) {
      case 'image-text':
        console.log('image-text');
        swiper = new Swiper(swiperWrap, {
          slidesPerView: 1,
          spaceBetween: 0,
          autoplay: {
            delay: 2500,
          },
          loop: true,
          pagination: {
            el: pagination,
          },
        });

        console.log(swiper);
        break;
      case 'testomonials':
        swiper = new Swiper(swiperWrap, {
          slidesPerView: 1,
          spaceBetween: 20,

          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          },
          pagination: {
            el: '.swiper-pagination',
          }
        });
        break;
      default:

      console.log('default');

      const scrollBar = swiperWrap.parentNode.querySelector('.swiper-scrollbar');
      console.log(scrollBar);




      const swiper = new Swiper(swiperWrap, {
        // Optional parameters
        slidesPerView: 4,
        loop: false,
        spaceBetween: 20,
        mousewheel: {
          forceToAxis: true, // Swiping is constrained to the axis, allowing natural scroll behavior
        },
    
        breakpoints: {
          0: {
            slidesPerView: 1.5,
    
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1224: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
        },
      
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      
        // And if we need scrollbar
        scrollbar: {
          el: scrollBar,
        },
      });





    }
  })


  




  

})


document.addEventListener('DOMContentLoaded', function() {
  const ourWorldItem = document.querySelector('.mobile-nav-content .navmenu-id-our-world');
  const openBtn = ourWorldItem.querySelector('.navmenu-button');
  const seconLevel = ourWorldItem.querySelector('.navmenu-depth-2 .navmenu-button');

  console.log(openBtn);
  console.log(seconLevel);



  openBtn.addEventListener('click', function() {
    console.log('clicked');
  

    // setTimeout(() => {
    //   seconLevel.click()
    // }, 500)
    
  })

  console.log(ourWorldItem);


})

